import { useSyncExternalStore } from 'react'
import { createPortal } from 'react-dom'
import { Check, CircleAlert, LoaderCircle, X } from 'lucide-react'
import { feedback, type FeedbackItem } from '../../lib/feedback'
import './feedback.css'

function FeedbackCard({ item }: { item: FeedbackItem }) {
  const loading = item.tone === 'loading'
  const waiting = item.progress === undefined || item.progress === 0
  return (
    <div className={`action-feedback action-feedback--${item.tone}`} role={item.tone === 'error' ? 'alert' : 'status'}>
      <span className="action-feedback__icon" aria-hidden="true">
        {loading ? <LoaderCircle /> : item.tone === 'success' ? <Check /> : <CircleAlert />}
      </span>
      <div className="action-feedback__copy">
        <p className="action-feedback__title">{item.title}</p>
        {item.detail ? <p className="action-feedback__detail">{item.detail}</p> : null}
        {loading ? (
          <div className="action-feedback__track" role="progressbar" aria-label={item.title}
            aria-valuemin={0} aria-valuemax={100}
            aria-valuenow={item.progress === undefined ? undefined : Math.round(item.progress * 100)}
            aria-valuetext={item.detail}>
            <span className={waiting ? 'is-indeterminate' : ''}
              style={waiting ? undefined : { width: `${(item.progress ?? 0) * 100}%` }} />
          </div>
        ) : null}
        {item.action ? <button className="action-feedback__retry" type="button" onClick={() => {
          feedback.dismiss(item.id)
          item.action?.run()
        }}>{item.action.label}</button> : null}
      </div>
      {!loading ? <button className="action-feedback__close" type="button" aria-label="Закрыть уведомление" onClick={() => feedback.dismiss(item.id)}><X size={16} /></button> : null}
    </div>
  )
}

/** Outside route content and form portals: closing a form cannot hide its result. */
export default function FeedbackHost() {
  const items = useSyncExternalStore(feedback.subscribe, feedback.getSnapshot, feedback.getSnapshot)
  if (typeof document === 'undefined') return null
  return createPortal(
    <div className="action-feedback-stack" aria-label="Результаты действий">
      {items.map((item) => <FeedbackCard item={item} key={item.id} />)}
    </div>, document.body,
  )
}
